import React from "react";
import { AiFillGithub, AiFillFacebook } from "react-icons/ai";
import { FaLinkedinIn, FaGooglePlay, FaEnvelope, FaMapMarkerAlt, FaPhone } from "react-icons/fa";
import pdf from "../../Assets/shanto_cv.pdf";
import { AiOutlineDownload } from "react-icons/ai";

const contactItems = [
  { icon: <FaEnvelope />,      label: "Email",    value: "sakibahmed21@iut-dhaka.edu",  href: "mailto:sakibahmed21@iut-dhaka.edu", color: "#a78bfa" },
  { icon: <FaPhone />,         label: "Phone",    value: "+880 1721 665453",             href: "tel:+8801721665453",                color: "#67e8f9" },
  { icon: <FaMapMarkerAlt />,  label: "Location", value: "Gazipur, Dhaka, Bangladesh",  href: null,                                color: "#4ade80" },
];

const socials = [
  { icon: <AiFillGithub />,   label: "GitHub",     href: "https://github.com/sakibahmedshanto",                          color: "#f0f0f0" },
  { icon: <FaLinkedinIn />,   label: "LinkedIn",   href: "https://www.linkedin.com/in/sakibsanto/",                      color: "#0a66c2" },
  { icon: <FaGooglePlay />,   label: "Play Store", href: "https://play.google.com/store/apps/developer?id=ahmedapps",   color: "#01875f" },
  { icon: <AiFillFacebook />, label: "Facebook",   href: "https://www.facebook.com/sakib.ahmed.shanto.910428/",          color: "#1877f2" },
];

function ContactSection() {
  return (
    <section id="contact" className="sp-section">
      <div className="sp-container">
        <div className="sp-section-header">
          <span className="section-label">Get in touch</span>
          <h2 className="section-title">
            Let's <span className="gradient-text">Connect</span>
          </h2>
          <p className="section-subtitle">
            Open to internships, freelance projects, and full-time Flutter/mobile roles. Let's build something amazing.
          </p>
        </div>

        <div className="contact-grid">
          {/* Left: info */}
          <div className="contact-info">
            <h3 className="contact-info-title">Reach out directly</h3>

            <div className="contact-items">
              {contactItems.map(({ icon, label, value, href, color }) => (
                <div className="contact-item" key={label}>
                  <div className="contact-item-icon" style={{ color, background: `${color}18`, border: `1px solid ${color}30` }}>
                    {icon}
                  </div>
                  <div>
                    <div className="contact-item-label">{label}</div>
                    {href ? (
                      <a href={href} className="contact-item-value" style={{ color }}>{value}</a>
                    ) : (
                      <div className="contact-item-value" style={{ color: "#f8fafc" }}>{value}</div>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* Socials */}
            <div className="contact-socials">
              {socials.map(({ icon, label, href, color }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  className="contact-social-btn"
                  style={{ "--s-color": color }}
                  title={label}
                >
                  {icon}
                  <span>{label}</span>
                </a>
              ))}
            </div>

            {/* Download CV */}
            <a href={pdf} target="_blank" rel="noreferrer" className="btn-primary-hero" style={{ width: "100%", justifyContent: "center", marginTop: "20px" }}>
              <AiOutlineDownload /> Download Full CV
            </a>
          </div>

          {/* Right: availability card */}
          <div className="contact-availability">
            <div className="availability-card">
              <div className="availability-header">
                <span className="badge-dot" style={{ width: "10px", height: "10px" }} />
                <span style={{ color: "#4ade80", fontWeight: 600 }}>Available for work</span>
              </div>
              <h3 style={{ fontSize: "1.4rem", fontWeight: 700, color: "#f8fafc", marginBottom: "14px" }}>
                Looking for the right opportunity
              </h3>
              <p style={{ color: "#94a3b8", fontSize: "0.92rem", lineHeight: 1.8, marginBottom: "20px" }}>
                I'm currently seeking <strong style={{ color: "#a78bfa" }}>Flutter developer roles</strong>, mobile
                engineering internships, or freelance projects. I bring 2+ years of production experience,
                end-to-end App Store &amp; Play Store lifecycle ownership, and a passion for clean, maintainable code.
              </p>

              <div className="availability-points">
                {[
                  "✅  iOS &amp; Android development (single Flutter codebase)",
                  "✅  App Store Connect &amp; Google Play Console lifecycle",
                  "✅  Firebase backend, REST API integration",
                  "✅  Clean Architecture, BLoC / GetX state management",
                  "✅  Available immediately for full-time or part-time roles",
                ].map((point, i) => (
                  <div key={i} className="avail-point" dangerouslySetInnerHTML={{ __html: point }} />
                ))}
              </div>

              <a
                href="mailto:sakibahmed21@iut-dhaka.edu"
                className="btn-primary-hero"
                style={{ marginTop: "24px", width: "100%", justifyContent: "center" }}
              >
                <FaEnvelope /> Send me an email
              </a>
            </div>
          </div>
        </div>

        {/* Footer bar */}
        <div className="contact-footer">
          <p>Designed &amp; Built by <strong className="gradient-text">Sakib Ahmed Shanto</strong> · 2025</p>
          <p style={{ fontSize: "0.8rem", color: "#475569", marginTop: "6px" }}>
            Flutter Developer · IUT · Gazipur, Bangladesh
          </p>
        </div>
      </div>
    </section>
  );
}

export default ContactSection;
